export default "__VITE_ASSET__DPf6bH$A__"